import { createEntityAdapter } from '@reduxjs/toolkit';
import { SettlementParams } from './settlements.types';

const adapter = createEntityAdapter<SettlementParams>({
  sortComparer: (a, b) => b.month.localeCompare(a.month),
});

export default adapter;
